import React, { useState, useEffect } from 'react'
import {
    Paper,
    Button,
    makeStyles,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { CenteredLayout } from './shared/CenteredLayout'
import serviceService from '../services/service.service'
import { ContentTitle } from '../components/shared/ContentTitle'
import { routingConstants } from '../constants/routing.constants'
import { userService } from '../services/user.service'

const useStyles = makeStyles(() => ({
    formControl: {
        minWidth: 120,
        maxWidth: 300,
    },
    centeredBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '548px',
        width: '100%',
    },
    submitButton: {
        marginLeft: '30px',
    },
}))

export const HomePage = () => {
    const history = useHistory()
    const classes = useStyles()

    const ServiceSelection = () => {
        const [serviceData, setServiceData] = useState([])
        const [selectedService, setSelectedService] = useState(undefined)

        useEffect(() => {
            ;(async function getAllServiceNamesAsync() {
                try {
                    setServiceData(await serviceService.getAllServiceNames())
                } catch (exception) {
                    console.log(exception)
                }
            })()
        }, [])

        const serviceSelectedHandler = () => {
            userService.setManagedService(selectedService)
            history.push(routingConstants.paths.serviceConfiguration)
        }

        return (
            <Paper className={classes.centeredBox}>
                <FormControl className={classes.formControl}>
                    <InputLabel>Service</InputLabel>
                    <Select
                        value={selectedService}
                        onChange={e => {
                            const selectedValue = e.target.value
                            setSelectedService(
                                serviceData.find(x => x.id === selectedValue)
                            )
                        }}>
                        <MenuItem value={undefined}>
                            {'Select Service'}
                        </MenuItem>
                        {serviceData.map(service => (
                            <MenuItem key={service.id} value={service.id}>
                                {service.value}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Button
                    className={classes.submitButton}
                    variant='contained'
                    color='secondary'
                    onClick={serviceSelectedHandler}
                    disabled={selectedService === undefined}>
                    Select
                </Button>
            </Paper>
        )
    }

    return (
        <CenteredLayout>
            <ContentTitle pageTitle={'Service'} />
            <ServiceSelection />
        </CenteredLayout>
    )
}
